import React, { Component } from "react";
import { styled } from "../../../../stitches.config";

import { withlazyload } from "../../../HOCs/WithLazyLoad";

@withlazyload({
    height: 480,
    once: true,
    offset: 500
})
export default class GoogleMaps extends Component {
    render() {
        return (
            <CenteredEmbed>
                <iframe src={this.props.src} width="600" height="450" frameBorder="0" allowFullScreen=""></iframe>
            </CenteredEmbed>
        );
    }
}

const CenteredEmbed = styled("div",{
    position: "relative",
    paddingBottom: "56.25%",
    paddingTop: "25px",
    height: "0",
    "& > iframe": {
      margin: "20px auto !important",
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%"
    }
});